/* eslint-disable */
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ActionCreators from "../../actions";
import { setLyftReportData, setTuroReportData, setOtherReportData } from "../../utils/functions";
import { getCertificateFontDownloads } from "../../utils/certificateFontDownloads";
import "./certificateDownloadButton.css";

import React from "react";
import moment from "moment";
import {
  PDFDownloadLink,
  Page,
  Text,
  View,
  Image,
  Document,
  StyleSheet,
  Font,
  Svg,
  Path,
} from "@react-pdf/renderer";
import {
  handDrawnCirclePath,
  HAND_DRAWN_CIRCLE_VIEWBOX,
} from "../../utils/handDrawnCircle";
// import { imageBaseUrl } from "../utils/api";
import LyftImg from "../../Assets/lyftimg.png";
import TicketImg from "../../Assets/tickimg.png";
import kalamFont from "../../font/Kalam-Light.ttf";
import "../../font/registerPatrickHandAndCaveatPdf";

Font.register({ family: "kalamFont", format: "truetype", src: kalamFont });

const styles = StyleSheet.create({
  body: {
    paddingBottom: 65,
  },
  headerWidth: {
    paddingHorizontal: 10,
    marginBottom: "25px",
  },
  header: {
    backgroundColor: "#47484F",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "12px",
  },
  californiaText: {
    color: "white",
    fontSize: "20px",
    textTransform: "uppercase",
  },
  boxContainer: {
    borderWidth: 1,
    borderColor: "#141414",
    backgroundColor: "#E4E5E7",
    padding: "10px",
  },
  lyftdrivertextContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: "15px",
  },
  boxWidth: {
    paddingHorizontal: 20,
    paddingTop: 10,
  },
  lyftdriverText: {
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: "bold",
    // lineHeight: "42px",
    color: "black",
  },
  allfieldsText: {
    color: "#8E8B8C",
    fontSize: "10px",
    fontWeight: "400",
    marginLeft: "8px",
  },
  nameinputContainer: {
    borderWidth: 1,
    borderColor: "#47484F",
    marginTop: "10px",
    width: "100%",
  },
  lyftdriverName: {
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: "400",
    // lineHeight: "23px",
    color: "#47484F",
    marginBottom: 0,
    marginLeft: "10px",
    marginTop: "3px",
  },
  nameText: {
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: "400",
    // fontFamily: 'kalamFont',
    // lineHeight: "23px",
    color: "black",
    marginLeft: "30%",
    marginBottom: "0px",
  },
  threeinputfieldContainer: {
    flexDirection: "row",
    alignItems: "center",
  },
  nameinputContainerOne: {
    borderWidth: 1,
    borderColor: "#47484F",
    marginTop: "10px",
    width: "30%",
    marginRight: "10px",
  },
  nameinputContainerTwo: {
    borderWidth: 1,
    borderColor: "#47484F",
    marginTop: "10px",
    width: "30%",
    marginRight: "10px",
  },
  nameinputContainerThree: {
    borderWidth: 1,
    borderColor: "#47484F",
    marginTop: "10px",
    width: "40%",
  },
  threeinputFields: {
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "300",
    marginBottom: "0px",

    // lineHeight: "23px",
    color: "black",
    marginLeft: "50%",
    // fontFamily: 'kalamFont',
  },
  licenseplateContainer: {
    borderWidth: 1,
    borderColor: "#47484F",
    width: "35%",
    marginRight: "10px",
  },
  codeText: {
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: "300",
    // lineHeight: "23px",
    color: "black",
    marginLeft: "50%",
    // fontFamily: 'kalamFont',
  },
  vinContainer: {
    fontSize: "12px",
    fontWeight: "30",
    fontStyle: "normal",
    color: "black",
  },
  twoinputfieldContainer: {
    flexDirection: "row",
    alignItems: "flex-start",
    marginTop: "10px",
    marginBottom: "10px",
  },
  vintopBorder: {
    borderTopWidth: 1,
    borderTopColor: "#47484F",
    width: "100%",
  },
  vinComb: {
    flexDirection: "row",
    width: "100%",
    marginTop: 6,
    borderLeftWidth: 1,
    borderLeftColor: "#47484F",
  },
  vinCell: {
    flex: 1,
    height: 32,
    alignItems: "center",
    justifyContent: "center",
    borderRightWidth: 1,
    borderRightColor: "#47484F",
    borderBottomWidth: 1,
    borderBottomColor: "#47484F",
  },
  vinChar: {
    fontSize: 12,
  },
  topText: {
    marginTop: "30px",
    fontSize: "12px",
    paddingLeft: "8px",
    // fontFamily: 'kalamFont',
    paddingRight: "10px",
    marginBottom: "-3px",
  },
  vehicleinspectionPadding: {
    paddingHorizontal: "30px",
    paddingTop: "10px",
  },
  checkboxesmainContainer: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: "30px",
  },
  checkboxesmainContainerTwo: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: "30px",
    marginTop: "10px",
  },
  inspectionfirstContainer: {
    width: "94%",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  inspectionsecondContainer: {
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  inspectionText: {
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: "500",
    // lineHeight: "21px",
    color: "#716E6E",
    textTransform: "uppercase",
  },
  inspectiontextTwo: {
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: "500",
    // lineHeight: "21px",
    color: "#716E6E",
    marginLeft: "15px",
    textTransform: "uppercase",
  },
  passText: {
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: "500",
    // lineHeight: "21px",
    color: "#716E6E",
    marginRight: "15px",
    textTransform: "uppercase",
  },
  failText: {
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: "500",
    // lineHeight: "21px",
    color: "#716E6E",
    textTransform: "uppercase",
  },
  passfailContainer: {
    flexDirection: "row",
    alignItems: "center",
  },
  numbersText: {
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: "500",
    // lineHeight: "21px",
    color: "#716E6E",
  },
  detailsText: {
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "500",
    // lineHeight: "21px",
    // width:'75%',
    color: "black",
    marginLeft: "5px",
  },
  failpassbox: {
    borderStyle: "dashed",
    borderWidth: 1,
    borderColor: "black",
    marginLeft: "15px",
    width: "92%",
    padding: "10px",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-around",
    position: "absolute",
    height: "50px",
    top: 10,
  },

  boxinspectionText: {
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "600",
    // lineHeight: "21px",
    color: "black",
    textTransform: "uppercase",
  },
  circleoneText: {
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: "400",
    // lineHeight: "21px",
    color: "#716E6E",
    marginTop: "5px",
  },
  boxpassText: {
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "700",
    // lineHeight: "21px",
    color: "black",
  },
  orangeCircle: {
    borderWidth: 3,
    borderColor: "#000",
    borderRadius: "50%",
    height: "55px",
    width: "55px",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  resultCircleWrap: {
    width: 55,
    height: 55,
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
  },
  resultCircle: {
    position: "absolute",
    width: 74,
    height: 46,
    left: -9,
    top: 4,
  },
  boxfailText: {
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "700",
    // lineHeight: "21px",
    color: "black",
  },
  boxinspectionContainer: {
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  tobecompletedContainer: {
    backgroundColor: "#E4E5E7",
    padding: "10px",
  },
  tobecompletedWidth: {
    paddingHorizontal: "30px",
    marginTop: "75px",
  },
  tobecompletedtextContainer: {
    flexDirection: "row",
    alignItems: "center",
  },
  tobecompletedText: {
    fontSize: 12,
    fontStyle: "normal",
    fontWeight: "700",
    // lineHeight: "23px",
    color: "black",
    textDecoration: "underline",
    textTransform: "uppercase",
  },
  fieldsText: {
    fontSize: 8,
    fontStyle: "normal",
    fontWeight: "700",
    // lineHeight: "21px",
    color: "#716E6E",
    textTransform: "uppercase",
  },

  inpectionText: {
    fontSize: "14px",
    color: "#47484F",
    fontWeight: "bold",
    textTransform: "uppercase",
  },
  documentexpiryText: {
    fontSize: "10px",
    color: "#47484F",
  },
  dateText: {
    fontSize: "16px",
    // fontFamily: 'kalamFont',
    letterSpacing: "1px",
  },
  datemainContainer: {
    marginTop: "-12px",
    marginLeft: "52%",
  },
  namesfieldscontainer: {
    flexDirection: "row",
    // alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    marginTop: "18px",
    alignItems: "flex-end",
  },
  borderWidth: {
    borderBottomWidth: 1,
    borderBottomColor: "black",
  },
  topName: {
    fontSize: "14px",
    color: "black",
    // fontFamily: 'kalamFont',
    marginLeft: "12px",
    marginBottom: "0px",
  },
  bottomName: {
    fontSize: "12px",
    color: "#47484F",
    textTransform: "uppercase",
  },
  bottomPara: {
    paddingHorizontal: "30px",
    fontSize: 10,
    marginTop: "15px",
    color: "#716E6E",
  },
  tickpassContainer: {
    borderWidth: 1,
    borderColor: "black",
    height: "14px",
    width: "14px",
    justifyContent: "center",
    alignItems: "center",
    marginRight: "28px",
  },
  tickfailContainer: {
    borderWidth: 1,
    borderColor: "black",
    height: "14px",
    width: "14px",
    justifyContent: "center",
    alignItems: "center",
    marginRight: "28px",
  },
  inspectiondateContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    width: "85%",
  },
});

// Renders PASS/FAIL with a hand-drawn (human-like) circle around the selected
// result, matching the other certificates.
const CircledResult = ({ selected, children }) => (
  <View style={styles.resultCircleWrap}>
    {selected ? (
      <Svg style={styles.resultCircle} viewBox={HAND_DRAWN_CIRCLE_VIEWBOX}>
        <Path
          d={handDrawnCirclePath}
          stroke="#000"
          strokeWidth={3}
          strokeLinecap="round"
          fill="none"
        />
      </Svg>
    ) : null}
    <Text style={styles.boxpassText}>{children}</Text>
  </View>
);

function LyftCertificateDownLoad({
  certificateData,
  vehicleChecksArray,
  handwritingFont = "kalamFont",
  fileName = "Vehicle-certificate.pdf",
  linkLabel = "Download pdf",
}) {
  const handwritingStyle = { fontFamily: handwritingFont };

  return (
    <div className="App">
      <PDFDownloadLink
        wrap={false}
        document={
          <Document>
            {/* Auto-height page (A3 width, min A3 height) so the certificate always fits on a single page */}
            <Page size={{ width: 841.89 }} style={[styles.body, { minHeight: 1190.55 }]} wrap={false}>
              <View style={styles.headerWidth}>
                <View style={styles.header}>
                  <Image style={{ width: "40px" }} source={LyftImg} />
                  <Text style={styles.californiaText}>
                    CALIFORNIA VEHICLE INSPECTION
                  </Text>
                </View>
              </View>
              <View style={styles.boxWidth}>
                <View style={styles.boxContainer}>
                  <View style={styles.lyftdrivertextContainer}>
                    <Text style={styles.lyftdriverText}>LYFT DRIVER INFO</Text>
                    <Text style={styles.allfieldsText}>
                      [ALL FIELDS ARE MANDATORY]
                    </Text>
                  </View>

                  <View style={styles.nameinputContainer}>
                    <Text style={styles.lyftdriverName}>LYFT DRIVER NAME</Text>
                    <Text style={[styles.nameText, handwritingStyle]}>
                      {certificateData &&
                        `${certificateData?.Username} ${
                             certificateData?.UserlastName
                          
                        }`}
                    </Text>
                  </View>
                  <View style={styles.nameinputContainer}>
                    <Text style={styles.lyftdriverName}>PHONE NUMBER</Text>
                    <Text style={[styles.nameText, handwritingStyle]}>
                      {certificateData && certificateData.Userphone}
                    </Text>
                  </View>
                  <View style={styles.threeinputfieldContainer}>
                    <View style={styles.nameinputContainerOne}>
                      <Text style={styles.lyftdriverName}>VEHICLE YEAR</Text>
                      <Text style={[styles.threeinputFields, handwritingStyle]}>
                        {certificateData && certificateData.year}
                      </Text>
                    </View>
                    <View style={styles.nameinputContainerTwo}>
                      <Text style={styles.lyftdriverName}>VEHICLE MAKE</Text>
                      <Text style={[styles.threeinputFields, handwritingStyle]}>
                        {certificateData && certificateData.make}
                      </Text>
                    </View>
                    <View style={styles.nameinputContainerThree}>
                      <Text style={styles.lyftdriverName}>VEHICLE MODEL</Text>
                      <Text style={[styles.threeinputFields, handwritingStyle]}>
                        {certificateData && certificateData.model}
                      </Text>
                    </View>
                  </View>

                  <View style={styles.twoinputfieldContainer}>
                    <View style={styles.licenseplateContainer}>
                      <Text style={styles.lyftdriverName}>LICENSE PLATE #</Text>
                      <Text style={[styles.codeText, handwritingStyle]}>
                        {certificateData && certificateData.licensePlateNumber}
                      </Text>
                    </View>
                    <View style={{ width: "65%" }}>
                      {certificateData && certificateData.vin ? (
                        <View style={styles.vinComb}>
                          {certificateData.vin.split("").map((char, index) => (
                            <View key={index} style={styles.vinCell}>
                              <Text style={[styles.vinChar, handwritingStyle]}>
                                {char}
                              </Text>
                            </View>
                          ))}
                        </View>
                      ) : null}
                      <Text style={styles.vinContainer}>VIN</Text>
                    </View>
                  </View>
                </View>
              </View>
              <View style={styles.vehicleinspectionPadding}>
                <View style={styles.lyftdrivertextContainer}>
                  <Text style={styles.lyftdriverText}>VEHICLE INSPECTION</Text>
                  <Text style={styles.allfieldsText}>
                    [TO BE COMPLETED BY INSPECTOR]
                  </Text>
                </View>
              </View>

              <View style={{ flexDirection: "row", paddingHorizontal: "30px" }}>
                <View style={{ flexDirection: "column", width: "50%" }}>
                  <View style={styles.inspectionfirstContainer}>
                    <Text style={styles.inspectionText}>Inspection Point</Text>
                    <View style={styles.passfailContainer}>
                      <Text style={styles.passText}>Pass</Text>
                      <Text style={styles.failText}>Fail</Text>
                    </View>
                  </View>

                  {vehicleChecksArray?.map((check, index) =>
                    index <= 11 ? (
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "space-between",
                          marginTop: "10px",
                        }}
                      >
                        <View
                          style={{ flexDirection: "row", alignItems: "center" }}
                        >
                          <Text style={styles.numbersText}>{index + 1}.</Text>
                          <Text style={styles.detailsText}>
                            {check.Check.name}
                          </Text>
                        </View>
                        <View style={styles.passfailContainer}>
                          {check.status == true || check.status == 1 ? (
                            <View style={styles.tickpassContainer}>
                              <Image
                                style={{ width: "16px", marginLeft: "2px" }}
                                source={TicketImg}
                              />
                            </View>
                          ) : (
                            <View style={styles.tickpassContainer}></View>
                          )}
                          {check.status == false || check.status == 0 ? (
                            <View style={styles.tickfailContainer}>
                              <Image
                                style={{ width: "16px", marginLeft: "2px" }}
                                source={TicketImg}
                              />
                            </View>
                          ) : (
                            <View style={styles.tickfailContainer}></View>
                          )}
                        </View>
                      </View>
                    ) : null
                  )}
                </View>

                <View style={{ flexDirection: "column", width: "50%" }}>
                  <View style={styles.inspectionfirstContainer}>
                    <Text style={styles.inspectionText}>Inspection Point</Text>
                    <View style={styles.passfailContainer}>
                      <Text style={styles.passText}>Pass</Text>
                      <Text style={styles.failText}>Fail</Text>
                    </View>
                  </View>

                  {vehicleChecksArray?.map((check, index) =>
                    index > 11 ? (
                      <View
                        style={{
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "space-between",
                          marginTop: "10px",
                        }}
                      >
                        <View
                          style={{ flexDirection: "row", alignItems: "center" }}
                        >
                          <Text style={styles.numbersText}>{index + 1}.</Text>
                          <Text style={styles.detailsText}>
                            {check.Check.name}
                          </Text>
                        </View>
                        <View style={styles.passfailContainer}>
                          {check.status == true || check.status == 1 ? (
                            <View style={styles.tickpassContainer}>
                              <Image
                                style={{ width: "16px", marginLeft: "2px" }}
                                source={TicketImg}
                              />
                            </View>
                          ) : (
                            <View style={styles.tickpassContainer}></View>
                          )}
                          {check.status == false || check.status == 0 ? (
                            <View style={styles.tickfailContainer}>
                              <Image
                                style={{ width: "16px", marginLeft: "2px" }}
                                source={TicketImg}
                              />
                            </View>
                          ) : (
                            <View style={styles.tickfailContainer}></View>
                          )}
                        </View>
                      </View>
                    ) : null
                  )}

                  <View
                    style={[
                      styles.inspectionsecondContainer,
                      { marginTop: "20px", marginLeft: -10 },
                    ]}
                  >
                    <View style={styles.failpassbox}>
                      <View style={styles.boxinspectionContainer}>
                        <Text style={styles.boxinspectionText}>
                          VEHICLE INSPECTION
                        </Text>
                        <Text style={styles.circleoneText}>
                          (Please circle one)
                        </Text>
                      </View>
                      <CircledResult
                        selected={certificateData?.finalStatus === "pass"}
                      >
                        PASS
                      </CircledResult>
                      <CircledResult
                        selected={certificateData?.finalStatus === "fail"}
                      >
                        FAIL
                      </CircledResult>
                    </View>
                  </View>
                </View>
              </View>
              <View style={styles.tobecompletedWidth}>
                <View style={styles.tobecompletedContainer}>
                  <View style={styles.tobecompletedtextContainer}>
                    <Text style={styles.tobecompletedText}>
                      to be completed by inspector only{" "}
                    </Text>
                    <Text style={styles.fieldsText}>
                      [all fields are mandatory]
                    </Text>
                  </View>
                  <View style={styles.datemainContainer}>
                    <Text style={styles.inpectionText}>Inspection date</Text>
                    <View style={styles.inspectiondateContainer}>
                      <Text style={styles.documentexpiryText}>
                        (document expires one year from this date)
                      </Text>
                      <Text style={[styles.dateText, handwritingStyle]}>
                        {moment(
                          new Date(
                            certificateData && certificateData?.reviewedDate
                          )
                        ).format("MM/ DD /YYYY")}
                      </Text>
                    </View>
                  </View>
                  <View style={styles.namesfieldscontainer}>
                    <View style={{ width: "50%", marginRight: "20px" }}>
                      <Text style={[styles.topName, handwritingStyle]}>Chex Inc.</Text>
                      <View style={styles.borderWidth} />
                      <Text style={styles.bottomName}>Company Name</Text>
                    </View>
                    <View style={{ width: "50%" }}>
                      <Text style={[styles.topName, handwritingStyle]}>
                        {certificateData && certificateData.milage}
                      </Text>
                      <View style={styles.borderWidth} />
                      <Text style={styles.bottomName}>
                        vehicle mileage from odometer
                      </Text>
                    </View>
                  </View>
                  <View style={styles.namesfieldscontainer}>
                    <View style={{ width: "50%", marginRight: "20px" }}>
                      <Text style={[styles.topName, handwritingStyle]}>
                        {`${certificateData && certificateData?.stateAddress}`}
                      </Text>
                      <View style={styles.borderWidth} />
                      <Text style={styles.bottomName}>Company Address</Text>
                    </View>
                    <View style={{ width: "50%" }}>
                      <Text style={[styles.topName, handwritingStyle]}>{`${
                        certificateData && certificateData.Inspectorname
                      } ${
                        certificateData && certificateData.InspectorlastName
                      }`}</Text>
                      <View style={styles.borderWidth} />
                      <Text style={styles.bottomName}>inspector name</Text>
                    </View>
                  </View>
                  <View style={styles.namesfieldscontainer}>
                    <View
                      style={{
                        width: "50%",
                        marginRight: "20px",
                        marginTop: "10px",
                      }}
                    >
                      <Text style={[styles.topName, handwritingStyle]}>
                        {`${certificateData && certificateData?.stateNumber}`}
                      </Text>
                      <View style={styles.borderWidth} />
                      <Text style={styles.bottomName}>ard number</Text>
                    </View>
                    <View style={{ width: "50%", marginTop: "10px" }}>
                      {/* <Text style={[styles.topName, handwritingStyle]}>12122</Text> */}
                      <Image
                        style={{
                          position: "absolute",
                          height: "100px",
                          width: "150px",
                          top: "-75px",
                          right: "100px",
                        }}
                        src={`${process.env.REACT_APP_AWS_S3_LINK}/${
                          certificateData && certificateData.Inspectorsignature
                        }?x-request=xhr`}
                      />
                      <View style={styles.borderWidth} />
                      <Text style={styles.bottomName}>inspector signature</Text>
                    </View>
                  </View>
                </View>
              </View>
              <Text style={styles.bottomPara}>
                Applicants who do not match the photo on their driver’s license
                or do not have the proper documents, cannot complete an
                inspection. Failing inspections can only be remedied by the same
                shop on the same day. If an applicant fails the inspection and
                is unable to fix the issues on the spot, a new appointment must
                be made, and a new inspection form must be used.
              </Text>
              <Text style={styles.bottomPara}>
                This inspection form reflects a 19 point inspection only on the
                date of the inspection listed above. For purposes of this
                inspection, the wheels were not removed from the vehicle, and
                the vehicle was not put on a lift, nor was it checked for
                emissions.
              </Text>
            </Page>
          </Document>
        }
        fileName={fileName}
      >
        {({ blob, url, loading, error }) => (
          <>
            {loading ? (
              <div className="certificate-download-button is-loading" aria-live="polite">
                <span className="certificate-download-spinner" />
                <div>Preparing PDF</div>
              </div>
            ) : (
              <div
                className="certificate-download-button"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    fontSize: "15px",
                    marginBottom: "20px",
                    marginTop: "20px",
                    color: "#3FA9FF",
                    fontWeight: "bold",
                    marginRight: "5px",
                  }}
                >
                  {linkLabel}
                </div>
                <i className="fa fa-download" />
              </div>
            )}
          </>
        )}
      </PDFDownloadLink>
    </div>
  );
}


const LyftCertificateDownLoadConnected = (props) => {
  const { id, companyId, reportData, checksData } = props;
  React.useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      props.getVehicleCertificate({ id, companyId }, props.setLoading, "template3");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyId]);
  return (
    <div className="certificate-download-group">
      {!reportData ? (
        <div className="certificate-download-button is-loading" aria-live="polite">
          <span className="certificate-download-spinner" />
          <div>Loading certificate data</div>
        </div>
      ) : (
        getCertificateFontDownloads(reportData?.certificateFont).map((cfg) => (
          <LyftCertificateDownLoad
            key={cfg.handwritingFont}
            reportData={reportData} certificateData={reportData}
            checksData={checksData} checks={checksData} vehicleChecksArray={checksData} firstHalfData={checksData}
            handwritingFont={cfg.handwritingFont}
            fileName={cfg.fileName}
            linkLabel={cfg.linkLabel}
          />
        ))
      )}
    </div>
  );
};

function mapStateToProps(state) {
  const sliceData = state && state.vehicleInstruction && state.vehicleInstruction.lyftVehicleCertificate;
  return {
    reportData: sliceData,
    checksData: setLyftReportData(sliceData && sliceData.Files),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(LyftCertificateDownLoadConnected);
